import { HttpRequestResponse } from '../models/web/http-request-response';
import { GetPagedResponse } from '../models/web/get-paged-response';
import axiosPrivate from '../models/axios/axios-private';
import { GET_NEWS_ENDPOINT } from '../constants';
import { AxiosError, AxiosResponse } from 'axios';
import { News } from '../models/news';
import { getEndpointResponse } from '../utils/endpoint-response';

export const getNews = async (): Promise<HttpRequestResponse<News[]>> => {
  const response: AxiosResponse | AxiosError = await axiosPrivate
    .get<GetPagedResponse<News>>(GET_NEWS_ENDPOINT)
    .catch((err: AxiosError): AxiosError => err);

  return getEndpointResponse(response);
};
